import React from "react";

export const XconsIcon = () => (
  <svg
    width="24"
    height="23"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.8167 18.1376C24.6447 17.0066 24.6447 15.1653 25.8167 14.0323L31.4155 8.6293C33.4099 6.70463 33.4099 3.57355 31.4155 1.64888C30.4491 0.716301 29.1661 0.202393 27.7988 0.202393C26.4314 0.202393 25.1484 0.716301 24.182 1.64888L18.5832 7.05186C17.4112 8.18286 15.5032 8.18286 14.3291 7.05186L8.73029 1.64888C7.76392 0.718285 6.4809 0.204377 5.11357 0.204377C3.74625 0.204377 2.46323 0.718285 1.49891 1.64888C-0.495525 3.57355 -0.495525 6.70463 1.49891 8.6293L7.09773 14.0323C8.26972 15.1633 8.26972 17.0046 7.09773 18.1376L1.49891 23.5406C0.532536 24.4732 0 25.7113 0 27.0308C0 28.3483 0.532536 29.5884 1.49891 30.521C2.46529 31.4536 3.74831 31.9675 5.11563 31.9675C6.48295 31.9675 7.76597 31.4536 8.73235 30.521L14.3312 25.118C14.8987 24.5704 15.6553 24.2688 16.4572 24.2688C17.2591 24.2688 18.0157 24.5704 18.5832 25.118L24.182 30.521C26.1765 32.4457 29.421 32.4457 31.4155 30.521C33.4099 28.5963 33.4099 25.4653 31.4155 23.5406L25.8167 18.1376Z"
      fill="#85D025"
    />
  </svg>
);
